module.exports = __webpack_public_path__ + "img/demo-marketing-consultant-600x450.2932c0aa.jpg";